import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { DarkModeContextProvider } from "./contexts/darkModeContext";
import { Provider } from "react-redux";
import store from "./app/store";
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <DarkModeContextProvider>
        <App />
      </DarkModeContextProvider>
    </Provider>
  </React.StrictMode>
);
